// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1w_aW","footer":"styles_footer__3vKWv","passCodeTooltip":"styles_passCodeTooltip__zjEw0"};